import { sample } from 'effector';
import { chatShowOnlyMssages, chatTabsTypes } from '../../types/chat-tabs';
import { $activeChatTab, $showOnlyInMainChat, setActiveChatTab } from './chat-tabs.model';

$activeChatTab.on(setActiveChatTab, (_, tab) => tab);

/** Определяю в заивисимости от типа основного чата скрытие или нет сообщения показывать */
sample({
  clock: $activeChatTab,
  fn: (activeChatTab) =>
    activeChatTab === chatTabsTypes.applicant
      ? chatShowOnlyMssages.hidden
      : chatShowOnlyMssages.notHidden,
  target: $showOnlyInMainChat,
});
